import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 128px;
  min-width: fit-content;
  height: 52px;
  padding: 8px;
  background: ${(props) => props.theme.colors.surface_muted};
  border-radius: 6px;

  .description {
    padding: 0 8px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    .time-container {
      display: flex;
      justify-content: space-between;
      font-size: 13px;

      p {
        padding-right: 4px;
      }
    }
  }
`;

export default { Wrapper };
